import { TEEUP_IMAGES } from "@config/teeupImages"

// CREATE-COVER 2026-07-04: shared "never render without a cover" default-image helper. Originally
// lived only in TeeUpPhoto.tsx (card/detail render fallback); factored out here so the create form
// can seed the SAME deterministic bundled default from the moment it opens (rule: reuse the
// existing defaultCoverFor/TEEUP_IMAGES helper family, invent nothing new for the seed image).
// Resolve a CRA image require() (may be a string URL or { default: url }).
export const asUrl = img => (img && img.default) || img

// Deterministic char*31 rolling hash -- same algorithm the backend's _stable_hash (api/routers/
// coordination_objects.py) uses, so a given seed/name always resolves to the same pick on both
// ends. NOT the same table as the backend's auto_cover_for (that picks from the curated 16-cover
// Unsplash DEFAULT_COVERS set for topic-aligned AI adjustment -- see @config/autoCover); this one
// picks from the bundled offline TEEUP_IMAGES set used for the "never empty" seed default and for
// existing card/detail fallback rendering.
export const stableHash32 = seed => {
  const s = String(seed ?? "")
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return h
}

export const defaultCoverFor = seed => asUrl(TEEUP_IMAGES[stableHash32(seed) % TEEUP_IMAGES.length])
